
const digest = 'a9eca08d4426e507bb10f87a07428fa99b42a2aadd7805ff3f78b6623cfab823';
const classes = {"event":"_event_5npj3_1","resourceLabel":"_resourceLabel_5npj3_6"};
const css = `._event_5npj3_1 {
  font-weight: 600;
  min-height: 40px;
}

._resourceLabel_5npj3_6 {
  font-weight: 500;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  